module.exports = __webpack_public_path__ + "img/icon-restaurant-takeaway.3e67c7ee.png";